import * as Sentry from '@sentry/react';

type SocketType = 'chat' | 'notifications';

const ABNORMAL_DISCONNECT_REASONS = ['transport error', 'parse error'];

export const sentryCaptureSocketError = (data: {
  socketType: SocketType;
  event: 'connect_error' | 'error' | 'disconnect' | 'reconnect_failed';
  error?: Error;
  reason?: string;
  reconnectAttempts?: number;
}) => {
  const { socketType, event, error, reason, reconnectAttempts } = data;

  // Only log abnormal disconnects (not intentional client disconnects)
  if (event === 'disconnect' && !ABNORMAL_DISCONNECT_REASONS.includes(reason || '')) {
    return;
  }

  const sentryMessage = [`Socket ${event}`, socketType, reason && `[${reason}]`]
    .filter(Boolean)
    .join(' · ');

  Sentry.captureException(new Error(sentryMessage), {
    fingerprint: ['socket_error', socketType, event, reason || 'no_reason'],
    tags: {
      type: 'socket_error',
      socket_type: socketType,
      event,
      disconnect_reason: reason,
    },
    extra: {
      reconnect_attempts: reconnectAttempts,
      original_error: error?.message,
      original_stack: error?.stack,
    },
  });
};
